<div class="icon" style="margin-left: auto; margin-right: auto; width: fit-content">
  <twaice-fe-svg-icon
    [size]="dense ? '20px' : '30px'"
    [name]="data.icon"
    [color]="data.color"
    [source]="data.iconSource ?? 'custom'"
  >
  </twaice-fe-svg-icon>
</div>
